import styled from 'styled-components';
import { Typography } from '@interstate/components/Typography';

export const MaskedDatePickerWrapper = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const MaskTypography = styled(Typography)<{
    $isVisible: boolean;
    $maskStyles: {
        top: string;
        left: string;
        width: string;
        height: string;
    };
}>`
    position: absolute;
    top: ${(props) => props.$maskStyles.top};
    left: ${(props) => props.$maskStyles.left};
    width: ${(props) => props.$maskStyles.width};
    height: ${(props) => props.$maskStyles.height};
    background-color: #ffffff;
    cursor: text;
    display: flex;
    align-items: center;
    opacity: ${(props) => (props.$isVisible ? 1 : 0)};
    visibility: ${(props) => (props.$isVisible ? 'visible' : 'hidden')};
    transition: opacity 0.1s ease, visibility 0.1s ease;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
